export default {"src":"/_next/static/media/toggl-hire-logo.dcad4dff.svg","height":28,"width":123,"blurWidth":0,"blurHeight":0};